import React, { FC } from 'react'
import { connect } from 'react-redux'
import Chart from '../components/Chart'
import { YELLOW, ORANGE, RED, GREEN, BLACK } from '../constants/colors'
import { DENSITY_HIGH, DENSITY_MODERATE, DENSITY_MEDIUM } from '../constants/thresholds'

const DENSITY_ZONES = [
  {
    value: DENSITY_MEDIUM,
    color: GREEN,
  },
  {
    value: DENSITY_MODERATE,
    color: YELLOW,
  },
  {
    value: DENSITY_HIGH,
    color: ORANGE,
  },
  {
    color: RED,
  },
]

let DENSITY_CHART = {
  name: 'Density',
  type: 'line',
  pointInterval: 60 * 1000,
  zones: DENSITY_ZONES,
  color: YELLOW,
}

const DENSITY_ADJUSTED = {
  name: 'Estimated status at Earth',
  type: 'scatter',
  tooltip: {
    crosshairs: true,
    pointFormat: '<b>{point.x:%H:%M}</b><br/>Density: <b>{point.y}</b><br/>',
  },
  zones: DENSITY_ZONES,
}

const DENSITY_SETTINGS = {
  unit: ' p/cm³',
  softMin: 3,
  xPlotLines: [],
}

const PLOT_LINE_SETTINGS = {
  color: BLACK,
  width: 1,
  zIndex: 10,
}

// ToDo: More accurate typing
interface DensityChartContainerProps {
  density: any
  densityAtEarth: any
  currentTime: Date
  error: boolean
}

const DensityChartContainer: FC<DensityChartContainerProps> = ({
  currentTime,
  error,
  density,
  densityAtEarth,
}) => {
  const series = {
    ...DENSITY_CHART,
    data: density,
  }
  const secondarySeries = {
    ...DENSITY_ADJUSTED,
    data: densityAtEarth,
  }

  return (
    <Chart
      id="density"
      title="Density"
      series={series}
      secondarySeries={secondarySeries}
      settings={getDensitySettings(currentTime)}
      error={error}
    />
  )
}

const getXPlotLines = (currentTime: Date) => {
  return [
    {
      ...PLOT_LINE_SETTINGS,
      value: currentTime.getTime(),
    },
  ]
}

const getDensitySettings = (currentTime: Date) => {
  return {
    ...DENSITY_SETTINGS,
    xPlotLines: getXPlotLines(currentTime),
  }
}

function mapStateToProps(state: DensityChartContainerProps) {
  const { density, currentTime } = state
  return {
    density: density.data,
    densityAtEarth: density.densityAtEarth,
    currentTime,
    error: density.error,
  }
}

export default connect(mapStateToProps)(DensityChartContainer)
